/**
 * get query params from URL(via default vue query object)
 * and pass it to component props
 */
export function routePropResolver (routeOptions) {
  let { query } = routeOptions
  let resultQuery = {}

  Object.keys(query).forEach(key => {
    // parse strings
    if (query[key].length && !['0', 'null', 'undefined', 'NaN'].includes(query[key])) {
      resultQuery[key] = query[key]
    }
    // parse numbers
    if (parseInt(query[key])) {
      resultQuery[key] = +query[key]
    }
  })
  return resultQuery
}

/**
 * validate route limit
 * API have default limit equals to 10, so we don't need send it
 * @param {int} limit
 * @return {boolean}
 */
export function isValidLimitQuery (limit) {
  // Commented until pagination logic/UI are implemented
  // return [20, 30, 40, 50, 100].includes(+limit)

  // Just simple validation now
  return +limit >= 10 && +limit <= 5000
}

/**
 * validate route page
 * API have default page equals to 0, so we don't need send it
 * @param {int} page
 * @return {boolean}
 */
export function isValidPageQuery (page) {
  return +page >= 1
}
